module.exports = __webpack_public_path__ + "img/8.d93103c6.jpg";